import { useGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { proDriverSupplierCityMatrixQuery } from "@/app/Reports/ProDriverSupplierReport/GraphQL/proDriverSupplierReportQuery";
import { ProDriverSupplierCityMatrix } from "@/app/Reports/ProDriverSupplierReport/Components/ProDriverSupplierCityMatrix";

interface Props {
  supplierId: string;
  rangeStartDate: string;
  rangeEndDate: string;
}

export function ProDriverSupplierCityMatrixDetail({
  supplierId,
  rangeStartDate,
  rangeEndDate,
}: Props) {
  const { data, isLoading } = useGqlQuery(proDriverSupplierCityMatrixQuery, {
    supplierId,
    rangeStartDate,
    rangeEndDate,
  });

  if (isLoading) {
    return <div className="p-4 text-sm text-gray-500">Loading routes…</div>;
  }

  return (
    <ProDriverSupplierCityMatrix
      movements={data?.proDriverSupplierCityMatrix ?? []}
    />
  );
}
